import { type InstallationInfo, type LocationData } from '@common/types/api';
import { type DateTimeUTC } from '@common/types/brandedTypes';
import { type BaseDevice, createBaseDeviceFromResponse } from '@common/types/models/Device';
import { type FullDeviceDataDifferentiator } from '@common/types/models/Device/DeviceAccessRequest';
import type User from '@common/types/models/User';
import { createUserFromResponse } from '@common/types/models/User';
import { parseTimestampAsUtc } from '@common/utils/datetime/isoTimestamp';

export type ErrorStatus = 'regular' | 'critical';

interface DeviceShort extends FullDeviceDataDifferentiator, BaseDevice {
  readonly location: LocationData;
  readonly errorStatus?: ErrorStatus;
  readonly owner?: User;
  readonly createdUtc?: DateTimeUTC;
}

export const createDeviceShortFromResponse = (apiDevice: InstallationInfo): DeviceShort => {
  const { lastConnectedAt, ...baseDevice } = createBaseDeviceFromResponse(apiDevice);
  let { name } = baseDevice;
  const {
    status,
    owner,
  } = apiDevice;

  let errorStatus: ErrorStatus | undefined;
  if (status?.activeAlarms > 0) {
    errorStatus = 'regular';
  }
  if (status?.activeCriticalAlarms > 0) {
    errorStatus = 'critical';
  }
  if (!name && owner) {
    const user = createUserFromResponse(owner);
    const fullName = user.fullName(true);
    if (fullName) {
      name = fullName;
    }
  }
  return {
    ...baseDevice,
    hasFullData: true,
    name,
    errorStatus,
    lastConnectedAt,
    location: apiDevice.location,
    owner: apiDevice.owner ? createUserFromResponse(apiDevice.owner) : undefined,
    createdUtc: apiDevice.createdUtc
      ? parseTimestampAsUtc(apiDevice.createdUtc)
      : undefined,
  };
};

export default DeviceShort;
